module.exports = __webpack_public_path__ + "static/media/buy3.5333f78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buy3.png
// module id = 431
// module chunks = 0